let usage = `
import icons from '@betao/ds/icons'

icons['arrow_right'] // => '<svg>...</svg>' code
`.slice(1);

export default {
  usage
};
